import styled from "styled-components";

export default function NotFound(){
    return(
        <Content>
            <div>
                <img src="/img/logo-amai.png" alt="" />
                <h1>Página não encontrada</h1>
            </div>
        </Content>
    )
}

const Content = styled.main`
    width: 100vw;
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #333;

    text-align: center;
    padding: 40px 20px;
    box-sizing: border-box;

    div{
        width: 40%;
        background-color: #FFFFFF;
        padding: 20px;
        border-radius: 10px;
    }

    h1 {
        font-size: 50px;
        font-weight: 600;
        margin-bottom: 30px;
        font-family: 'Poppins', sans-serif;

        animation: fadeUp 0.8s ease forwards;
        opacity: 0;
    }

    img {
        width: 400px;
        height: auto;
        opacity: 0;
        animation: fadeDown 0.8s ease 0.3s forwards;
    }

    @keyframes fadeDown {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes fadeUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        h1 {
            font-size: 28px;
        }

        img {
            width: 80%;
        }
    }
`;
